import {
  IFavoriteProjectsApi,
  IManagementBackendClient,
  IProjectsApi,
  IReconciliationReportsApi,
  ITransactionReportsApi,
  IQuicksightApi,
  IUsersApi,
} from "@lib/types";
import { BaseClient, type IHttpClientHandlers } from "../base-client";
import { FavoriteProjectsApi } from "./favorite-projects";
import { ProjectsApi } from "./projects";
import { UsersApi } from "./users";
import { QuicksightApi } from "./quicksight";
import { AudiencesApi } from "./audiences";
import { ReconciliationReports } from "./reconciliation-reports";
import { TransactionReports } from "./transaction-reports";

// TODO: Remove once partner-portal is off apps/web's old ManagementBackendClient
// and onto @lib/apis ManagementBackendClient with updated host token handlers
// (e.g. rxp-identity / Bearer) instead of the legacy localStorage "token" key.
const legacyTokenHandlers: IHttpClientHandlers = {
  onRequest(config) {
    config.headers.Authorization = localStorage.getItem("token");
    return config;
  },
};

export class ManagementBackendClient
  extends BaseClient
  implements IManagementBackendClient
{
  constructor(baseURL: string, handlers: IHttpClientHandlers = legacyTokenHandlers) {
    if (!baseURL) throw new Error("Base URL is required");

    super({
      baseURL,
      headers: {
        "Content-Type": "application/json",
      },
      handlers,
    });

    this.Users = new UsersApi(this._instance);
    this.Projects = new ProjectsApi(this._instance);
    this.Quicksight = new QuicksightApi(this._instance);
    this.FavoriteProjects = new FavoriteProjectsApi(this._instance);
    this.Audiences = new AudiencesApi(this._instance);
    this.ReconciliationReports = new ReconciliationReports(this._instance);
    this.TransactionReports = new TransactionReports(this._instance);
  }

  public Users: IUsersApi;
  public Projects: IProjectsApi;
  public Quicksight: IQuicksightApi;
  public FavoriteProjects: IFavoriteProjectsApi;
  public Audiences: AudiencesApi;
  public ReconciliationReports: IReconciliationReportsApi;
  public TransactionReports: ITransactionReportsApi;
}
